<p-dialog [(visible)]="visibleLukiModal" [modal]="true" [draggable]="false" [resizable]="false" position="bottom" (onHide)="onCloseModal()">
  <div class="dialog">
    <form [formGroup]="formLuki" (ngSubmit)="onLukiPayment()">
      <div class="container">
        <div class="wrapper">
          <div class="dialog__info">
            <h2 class="titleFlex"><span>Cuenta</span><i><img src="assets/images/logos/luki-logo.png" alt="LUKI"></i></h2>
            <p>La wallet que tenemos registrada con tu cuenta es: <strong><span class="noWrap">{{country.phoneCountryCode}} {{lukiStatus().luki_wallet_number}}</span></strong>.</p>
            <p class="pt-20">¿Deseas que realicemos el Cash IN en esta billetera?</p>
          </div>
          <div class="dialog__btn">
            <button pButton pRipple type="submit" label="Si, transferir dinero a mi wallet" class="p-button-primary p-button-raised p-button-rounded w-full" [loading]="loading"></button>
            <div class="dialog__btnFloat">
              <p-button label="No es mi wallet" [text]="true" [plain]="true"></p-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</p-dialog>
